const Button = ({
  text = "Start A Bid",
  onClick,
  className = "",
  bgColor,
  textColor,
  padding,
  fontSize,
  borderRadius,
  customStyle = {},
  primary,
  icon = false,
}) => {
  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    border: "none",
    ...(primary && {
      padding: "10px 20px",
      fontSize: "16px",
      borderRadius: "5px",
      backgroundColor: "#e82127",
      color: "#fff",
    }),
    ...(bgColor && { backgroundColor: bgColor }),
    ...(textColor && { color: textColor }),
    ...(padding && { padding }),
    ...(fontSize && { fontSize }),
    ...(borderRadius && { borderRadius }),
    ...customStyle,
  };

  return (
    <button
      className={`custom-btn ${primary ? "btn-primary" : "btn-secondary"} ${className}`}
      style={buttonStyle}
      onClick={onClick}
    >
      {text}
      {icon && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="25" y1="25" x2="75" y2="75" stroke="currentColor" strokeWidth="8" />
          <line x1="75" y1="40" x2="75" y2="75" stroke="currentColor" strokeWidth="8" />
          <line x1="40" y1="75" x2="75" y2="75" stroke="currentColor" strokeWidth="8" />
        </svg>
      )}
    </button>
  );
};

export default Button;
